/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable import/order */
/* eslint-disable  @typescript-eslint/no-floating-promises */
/* eslint-disable  react-hooks/exhaustive-deps */

import React, { FC, useEffect } from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useGetServices } from '~/controllers/pricing';
import { ServicesKeys } from '~/types/Services';
import { useDirection } from '~/hooks/i18nHooks';
import { useGetApplication, useSelectStep } from '~/controllers/wizard';
import { useAmendment } from '~/controllers/amendment';
import InitialServicesCard from '~/components/views/ServicesView/InitialServicesCard';
import Form from '~/components/WizardForm';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import { CustomPricing, ProductMap } from '~/types/CustomPricing';
import buildNamePath from '~/utils/buildNamePath';
import { Draft } from '~/types/Draft';
import { getStagePayload } from '~/utils/getStagePayload';
import { isSales } from '~/utils/getDecodedJwt';

type PanelErrorType = Record<ServicesKeys, boolean>;
const initialPanelErrorState: PanelErrorType = {
  nGeniusPos: false,
  eCommerce: false,
  nGeniusGo: false,
  CORPORATE_EXECUTIVE_CARD: false,
  DIGITAL_BUSINESS_PAYMENT: false,
  DIGITAL_TRAVEL_PAYMENT: false,
  BUSINESS_CARD: false,
};

export type ServicesDraft = {
  services: Partial<ApplicationPayload['selectServices']>;
  productMap?: ProductMap;
  additionalConfigurations?: CustomPricing;
  productMapTemp?: any; // Prop to store some temporary data
  isAgreeWithServicesTermsAndConditions: boolean;
};
const SelectServices: FC<any> = (props) => {
  const { t } = useTranslation('fillApplication');
  const [form] = Form.useForm();
  const dir = useDirection();
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const servicesQuery = useGetServices();
  const selectStepMutation = useSelectStep();
  const sales = isSales();
  const { isAmendment, lockedProductKeys } = useAmendment();

  useEffect(() => {
    if (stagePayload?.activeStep?.uiKey !== 'selectServices') {
      selectStepMutation.mutateAsync('services.selectServices');
    }
  }, []);

  if (!servicesQuery.data?.services) return null;
  return (
    <>
      <Container>
        <Form<Draft<'selectServices'>> form={form} name="selectServices" stepKey="selectServices">
          <Typography.Title style={{ marginBottom: 20 }} level={1}>
            {t('Product Solutions')}
          </Typography.Title>
          <Typography.Paragraph style={{ marginBottom: 0 }} className="SelectServicesInitial-Paragraph">
            {t('Please select the product that best suits your business needs.')}
          </Typography.Paragraph>
          <Space className="SelecdfsdstServicesInitial-Space" size={40} direction="vertical">
            <div className="productsParents">
              {servicesQuery.data?.services?.map((item: any, index: number) => {
                const isLocked = isAmendment && lockedProductKeys.includes(item.type);
                return (
                  <CardContainer key={item?.type} type={item?.type}>
                    <InitialServicesCard
                      type={item?.type}
                      index={index}
                      key={item.key}
                      productKey={item.key}
                      inputKey={item.key}
                      name={item.name}
                      longDescription={item.longDescription}
                      disabled={isLocked}
                    />
                  </CardContainer>
                );
              })}
            </div>
          </Space>
        </Form>
      </Container>
    </>
  );
};
const n = buildNamePath('selectServices');
const Container = styled.div`
  margin-bottom: 100px;
  .sectionHeader {
    margin-top: 40px;
  }
  .productsParents {
    display: flex;
    flex-direction: column;
  }
`;

const CardContainer = styled.div<any>`
  margin-top: 40px;
  order: ${({ type }) => {
    if (type === 'BUSINESS_CARD') {
      return 1;
    }
    if (type === 'CORPORATE_EXECUTIVE_CARD') {
      return 2;
    }
    if (type === 'DIGITAL_BUSINESS_PAYMENT') {
      return 3;
    }
    if (type === 'DIGITAL_TRAVEL_PAYMENT') {
      return 4;
    }
    return 0;
  }};
`;

export default SelectServices;
